import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CadastroGenerico } from 'src/app/models/cad/cadastro-generico/cadastro-generico';
import { AbstractIdbaRequestModel } from 'src/app/shared/models/abstract-idba-request-model';
import { AbstractIdbaService } from 'src/app/shared/utils/abstract-idba-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CadastroGenericoService extends AbstractIdbaService {

  override model: CadastroGenerico;

  constructor(http: HttpClient) { 
    super(http, new CadastroGenerico());
    this.programName = "cad/genericos/cadgenerico.p";
  }

  pesquisarPorModuloAssunto(modulo: string, assunto: string)
  {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-listar-modulo-assunto";
    request.parameters = { modulo, assunto };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }
}
